<section *ngIf="!suggestedAlimentation && !isFetchingProducts">
  @if (mobileScreen) {
    <div class="suggested-alimentation-placeholder mobile-placeholder">
      <h3>Alimentação Sugerida</h3>
      <p class="placeholder-message">
        Selecione as <b>Características Clínicas</b> do <b>Pet</b> para a
        correta sugestão de alimentação.
      </p>
    </div>
  } @else {
    <div class="suggested-alimentation-placeholder">
      <h3>Alimentação Sugerida</h3>
      <p class="placeholder-message">
        Selecione as <b>Características Clínicas</b> do <b>Pet</b> para a
        correta sugestão de alimentação.
      </p>
    </div>
  }
</section>

<section *ngIf="isFetchingProducts">
  @if (mobileScreen) {
    <div class="suggested-alimentation-loading mobile-loading">
      <h3>Alimentação Sugerida</h3>
      <div class="mobile-loading-spinner-container">
        <div class="loading-spinner mobile-spinner">
          <app-generic-loading
            [isLoading]="true"
            [size]="16"
          ></app-generic-loading>
        </div>
        <p class="loading-message">Buscando a alimentação ideal...</p>
      </div>
    </div>
  } @else {
    <div
      class="suggested-alimentation-loading"
      data-testid="suggested-alimentation-loading"
    >
      <h3>Alimentação Sugerida</h3>
      <div class="loading-spinner">
        <app-generic-loading
          [isLoading]="true"
          [size]="16"
        ></app-generic-loading>
      </div>
      <p class="loading-message">Buscando a alimentação ideal...</p>
    </div>
  }
</section>

<section
  class="new-suggested-alimentation-section"
  *ngIf="suggestedAlimentation"
>
  <div class="section-header">
    <h3 class="section-title">Alimentação Sugerida</h3>
    <div
      class="section-header-alert-info"
      *ngIf="dryFoodMessage && !shouldShowEccMessage && !shouldShowAbove12YearsProductMessage"
    >
      <i class="bi bi-info-circle-fill"></i>
      <p [innerHTML]="dryFoodMessage"></p>
    </div>
    <div
      class="section-header-alert-info"
      *ngIf="shouldShowEccMessage"
    >
      <i class="bi bi-info-circle-fill"></i>
      <p [innerHTML]="dryFoodMessage || scoreMessage"></p>
    </div>

    <div
      class="section-header-alert-info"
      *ngIf="shouldShowAbove12YearsProductMessage"
    >
      <i class="bi bi-info-circle-fill"></i>
      <p [innerHTML]="osteoarticularDiseaseMessage"></p>
    </div>
    <!-- <div
      class="section-header-alert-info"
      *ngIf="getAssistedNutritionalSupportMessage()"
    >
      <i class="bi bi-info-circle-fill"></i>
      <p [innerHTML]="getAssistedNutritionalSupportMessage()"></p>
    </div> -->
    <!-- <div
      class="section-header-alert-info"
      *ngIf="getClinicalNutritionMessage()"
    >
      <i class="bi bi-info-circle-fill"></i>
      <p>
        {{ getClinicalNutritionMessage() }}
      </p>
    </div> -->
  </div>

  <div class="combine-food-container" *ngIf="isFoodCombination">
    <app-food-combination-banner
      [showBanner]="isFoodCombination"
      [wetPercentage]="wetPercentage"
      [dryPercentage]="dryPercentage"
      [combineFoodError]="combineFoodError"
      (percentageChange)="onPercentageChange($event)"
    ></app-food-combination-banner>
  </div>

  <div class="food-type-container">
    <section class="food-type-section">
      <h4 class="food-type-title">Alimentação Completa</h4>
      <div class="complete-food-container">
        <app-food-suggestion-card
          *ngIf="!!selectedDryFood"
          [enabled]="true"
          [checked]="isDryFoodSelected"
          [isCompleteFood]="true"
          [foodType]="'dry'"
          [product]="selectedDryFood"
          [speciePet]="speciePet"
          [petSelected]="petSelected"
          [nutritionalGuidanceForm]="nutritionalGuidanceForm"
          [isRecalculatingValues]="isRecalculatingValues"
          (checkboxChanged)="onDryFoodCheckboxChanged($event)"
          (productSelected)="onDryFoodProductSelected($event)"
          (portionsChanged)="onDryFoodPortionsChanged($event)"
        ></app-food-suggestion-card>
        <app-food-suggestion-card
          *ngIf="!!selectedCompleteWetFood"
          [enabled]="true"
          [checked]="isCompleteWetFoodSelected"
          [isCompleteFood]="true"
          [foodType]="'wet'"
          [product]="selectedCompleteWetFood"
          [speciePet]="speciePet"
          [petSelected]="petSelected"
          [nutritionalGuidanceForm]="nutritionalGuidanceForm"
          [isRecalculatingValues]="isRecalculatingValues"
          (checkboxChanged)="onCompleteWetFoodCheckboxChanged($event)"
          (productSelected)="onCompleteWetFoodProductSelected($event)"
          (portionsChanged)="onCompleteWetFoodPortionsChanged($event)"
        ></app-food-suggestion-card>
      </div>
    </section>
    <section class="food-type-section" *ngIf="!shouldHideTreatsSelection">
      <h4 class="food-type-title">
        Petiscos adicionais
        <div class="optional-tag">
          <p>Opcional</p>
        </div>
      </h4>
      <div class="snack-food-container">
        <app-food-suggestion-card
          *ngIf="!!selectedCookie"
          [enabled]="true"
          [checked]="isCookieSelected"
          [isCompleteFood]="false"
          [foodType]="'cookie'"
          [product]="selectedCookie"
          [speciePet]="speciePet"
          [petSelected]="petSelected"
          [nutritionalGuidanceForm]="nutritionalGuidanceForm"
          (checkboxChanged)="onCookieCheckboxChanged($event)"
          (productSelected)="onCookieProductSelected($event)"
          [isCookieSelected]="isCookieSelected"
          [isSnackWetFoodSelected]="isSnackWetFoodSelected"
        ></app-food-suggestion-card>
        <app-food-suggestion-card
          *ngIf="!!selectedSnackWetFood"
          [enabled]="true"
          [checked]="isSnackWetFoodSelected"
          [isCompleteFood]="false"
          [foodType]="'snack'"
          [product]="selectedSnackWetFood"
          [speciePet]="speciePet"
          [petSelected]="petSelected"
          [nutritionalGuidanceForm]="nutritionalGuidanceForm"
          (checkboxChanged)="onSnackWetFoodCheckboxChanged($event)"
          (productSelected)="onSnackWetFoodProductSelected($event)"
          [isCookieSelected]="isCookieSelected"
          [isSnackWetFoodSelected]="isSnackWetFoodSelected"
        ></app-food-suggestion-card>
      </div>
    </section>
  </div>
</section>
<section
  *ngIf="suggestedAlimentation && (suggestedAlimentation.dryFood.length > 0 || suggestedAlimentation.completeWetFood.length > 0)"
  class="gradual-change-container"
>
  @if (screenWidth < 768) {
    <div class="gradual-exchange-section gradual-exchange-mobile">
      <label class="gradual-change__label label-mobile">
        Realizar troca gradativa do Alimento?
        <ng-toggle
          class="toggle"
          data-testid="gradual-exchange-toggle"
          [value]="gradualExchange"
          [color]="{
            unchecked: '#becad2',
            checked: '#5eacff'
          }"
          [width]="50"
          [height]="24"
          (change)="addGradualChange()"
        ></ng-toggle>
      </label>
      <app-gradual-change-mobile
        class="w-100"
        [listProductsOfGradualChange]="listGradualExchanges.gradualExchanges"
        [gradualChange]="gradualExchange"
      >
      </app-gradual-change-mobile>
    </div>
  } @else {
    <div class="gradual-exchange-section">
      <label class="gradual-change__label">
        Realizar troca gradativa do Alimento?
        <ng-toggle
          class="toggle"
          data-testid="gradual-exchange-toggle"
          [value]="gradualExchange"
          [color]="{
            unchecked: '#becad2',
            checked: '#5eacff'
          }"
          [width]="50"
          [height]="24"
          (change)="addGradualChange()"
        ></ng-toggle>
      </label>
      <app-gradual-change
        class="w-100"
        [listProductsOfGradualChange]="listGradualExchanges.gradualExchanges"
        [gradualChange]="gradualExchange"
      >
      </app-gradual-change>
    </div>
  }
</section>
